import AppEvents from 'Shared/app-events';

import BookmarkApi from 'Api/bookmark-api';
import CompareApi from 'Api/compare-api';
import CartApi from 'Api/cart-api';

import Util from 'Common/util';
import { VariantItemModel } from 'Models/variantItemModel';

class BookmarkItem {
    constructor(module, data) {
        this.module = module;

        ko.mapping.fromJS(data, this.#mapping, this);
    }

    #mapping = {
        VariantItem: {
            create: (options) => new VariantItemModel(options.data)
        }
    };

    addToCompare = (model, e) => {
        const element = e.currentTarget;

        Util.startLoading(element);

        CompareApi.addProduct(model.VariantItem.Id())
            .then(() => {
                AppEvents.emit("aside.compare.show");
            })
            .finally(() => {
                Util.stopLoading(element);
            });
    }

    addToCart = async (model, e) => {
        const element = e.currentTarget;
 
        Util.startLoading(element);

        try {
            await CartApi.addProduct({
                productId: model.VariantItem.Id()
            });

            AppEvents.emit("aside.cart.show");
        }
        finally {
            Util.stopLoading(element);
        }
    }

    removeItem = (model, e) => {
        const element = e.currentTarget;

        Util.startLoading(element);
        BookmarkApi.removeItem(model.Id())
            .always(() => {
                Util.stopLoading(element);
            });
    }
}

export default class BookmarkModule {

    constructor(data, view) {
        this.view = view;

        ko.mapping.fromJS(data, this.#mapping, this);

        this.loaded(true);
    }

    loading = ko.pureComputed(() => this.view.contextLoading());
    loaded = ko.observable(false);

    index = ko.pureComputed({
        read: () => this.OrderLists().findIndex(x => x.Id() == this.OrderListId()),
        write: (value) => {
            this.indexChange(this.OrderLists()[value]);
        },
        owner: this
    });

    #mapping = {
        Items: {
            key: (data) => ko.utils.unwrapObservable(data.Id),
            create: (options) => new BookmarkItem(this, options.data)
        }
    };

    hasItems = ko.pureComputed(() => this.loaded() && this.ItemCount());

    indexChange = (data) => {
        BookmarkApi.select(data.Id());
    }

    selectedList = ko.computed(() => this.OrderLists().find(x => x.Id() == this.OrderListId()));

    template = ko.pureComputed(() => "bookmark-container-tpl");

    hasNext = ko.pureComputed(() => this.loaded() && this.index() < this.OrderLists().length -1);
    next = () => {
        BookmarkApi.select(this.OrderLists()[this.index() + 1].Id());
    }

    hasPrev = ko.pureComputed(() => this.loaded() && this.index() > 0);
    prev = () => {
        BookmarkApi.select(this.OrderLists()[this.index() -1].Id());
    }

    fadeIn = element => {
        if (element.nodeType === 1) {
            $(element).hide().fadeIn();
        }
    };

    fadeOut = element => {
        if (element.nodeType === 1) {
            $(element).fadeOut(() => $(element).remove());
        }
    };

    dispose() {}
}